function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import _ from 'lodash';
import { isBlank } from 'underscore.string';
export var getCityToDisplay = function(location) {
    return (location === null || location === void 0 ? void 0 : location.rootType) === 'locality' && (location === null || location === void 0 ? void 0 : location.locality) ? location === null || location === void 0 ? void 0 : location.locality : location === null || location === void 0 ? void 0 : location.city;
};
export var hasStreetNumber = function(address) {
    var re = /^\d+$/;
    return address ? re.test(_.split(address, ' ')[0]) : false;
};
export var convertMetersToMiles = function() {
    var meters = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0.0;
    return meters * 0.000621371192;
};
export var buildLocationObjectFromGoogle = function(data) {
    var findByType = function(components, type) {
        return _.find(components, function(comp) {
            return _.includes(comp.types || [], type);
        });
    };
    return {
        streetNumber: _.get(findByType(data.address_components, 'street_number'), 'short_name'),
        streetName: _.get(findByType(data.address_components, 'route'), 'short_name'),
        ln1: [
            _.get(findByType(data.address_components, 'street_number'), 'short_name'),
            _.get(findByType(data.address_components, 'route'), 'short_name')
        ].join(' '),
        ln2: _.get(findByType(data.address_components, 'subpremise'), 'short_name', ''),
        city: _.get(findByType(data.address_components, 'locality'), 'short_name') || _.get(findByType(data.address_components, 'sublocality_level_1'), 'short_name') || _.get(findByType(data.address_components, 'administrative_area_level_3'), 'short_name') || _.get(findByType(data.address_components, 'neighborhood'), 'short_name'),
        county: _.get(findByType(data.address_components, 'administrative_area_level_2'), 'short_name'),
        state: _.get(findByType(data.address_components, 'administrative_area_level_1'), 'short_name'),
        zipcode: _.get(findByType(data.address_components, 'postal_code'), 'short_name'),
        country: _.get(findByType(data.address_components, 'country'), 'long_name')
    };
};
export var formatAddress = function(location) {
    var ln1 = location.ln1, ln2 = location.ln2, city = location.city, locality = location.locality, state = location.state, zipcode = location.zipcode, country = location.country;
    var preferredAddressAttributesExist = !_.isEmpty(_.reject([
        ln1,
        ln2,
        city,
        locality,
        state,
        zipcode
    ], isBlank));
    if (!preferredAddressAttributesExist && !isBlank(country)) {
        return country;
    }
    var cityPretty = getCityToDisplay(location);
    return _.reject([
        _.reject([
            ln1,
            ln2
        ], isBlank).join(', '),
        cityPretty,
        [
            state,
            zipcode
        ].join(' ')
    ], isBlank).join(', ');
};
export var formatAddressForCheckout = function(param) {
    var ln1 = param.ln1, ln2 = param.ln2;
    return _.reject([
        ln1,
        ln2
    ], isBlank).join(', ');
};
export var formatAddressShort = function(location) {
    var ln1 = location.ln1, ln2 = location.ln2, state = location.state;
    var cityPretty = getCityToDisplay(location);
    var displayFields = !ln1 ? [
        cityPretty,
        state
    ] : [
        ln1,
        ln2
    ];
    return _.reject(displayFields, isBlank).join(', ');
};
/**
 * Normalizes a stored address so that city reflects locality when available.
 * Fixes stale addresses persisted before the ECOMM-5736 locality fix, where
 * city was set from MapBox's "place" field instead of "locality" (e.g.,
 * "New York" instead of "Brooklyn" for NYC borough addresses).
 * Also updates the formatted `address` and `addressLong` strings to reflect the corrected city.
 */ export var normalizeStoredAddress = function(address) {
    if (!address || !address.locality || address.city === address.locality) {
        return address;
    }
    // Only normalize US addresses where locality represents boroughs/districts.
    // For non-US (e.g., Canada), locality may be a sub-community and city (from place) is correct.
    if (address.country && address.country !== 'US') {
        return address;
    }
    var oldCity = address.city, correctedCity = address.locality;
    var normalized = _object_spread_props(_object_spread({}, address), {
        city: correctedCity
    });
    // Update the formatted address strings if they contain the old city
    if (normalized.address && oldCity) {
        // Only replaces first occurrence — intentional so state names like "New York" are preserved in addressLong.
        // Known limitation: if oldCity appears in the street name, the street gets modified instead of the city.
        normalized.address = normalized.address.replace(oldCity, correctedCity);
    }
    if (normalized.addressLong && oldCity) {
        normalized.addressLong = normalized.addressLong.replace(oldCity, correctedCity);
    }
    return normalized;
};
export var formatAddressWithoutApt = function(param) {
    var ln1 = param.ln1, city = param.city, state = param.state, zipcode = param.zipcode, country = param.country;
    var preferredAddressAttributesExist = !_.isEmpty(_.reject([
        ln1,
        city,
        state,
        zipcode
    ], isBlank));
    if (!preferredAddressAttributesExist && !isBlank(country)) {
        return country;
    }
    return _.reject([
        _.reject([
            ln1
        ], isBlank).join(', '),
        city,
        [
            state,
            zipcode
        ].join(' ')
    ], isBlank).join(', ');
};
